module.exports = __webpack_public_path__ + "img/unknown.c29f9ce8.png";